module.exports = __webpack_public_path__ + "img/shield-check.ac5667fc.svg";